import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';

import config from '../.env.js';
import { getAuthStorage } from './authStorage.js';

// Configure Amplify once, before any auth or WebSocket use. This mirrors the
// mobile app's Amplify.configure (app/App.js): the same Cognito user pool,
// region and client id, read from the generated web env. It additionally routes
// Amplify v6's Cognito token provider through our storage seam, so where tokens
// are persisted is controlled in one place (see authStorage.js) instead of being
// hard-wired to Amplify's default.

let configured = false;

export function configureAmplify() {
  // Idempotent: safe to call on every startup, HMR reload, or StrictMode double
  // mount — only the first call takes effect.
  if (configured) {
    return;
  }

  Amplify.configure({
    Auth: {
      Cognito: {
        region: config.region,
        userPoolId: config.darwin_user_pool_id,
        userPoolClientId: config.darwin_user_pool_client_id,
      },
    },
  });

  // ORDER IS REQUIRED: this MUST run after Amplify.configure() above.
  // Amplify.configure() resets the Cognito token provider's key-value storage
  // back to defaultStorage (localStorage) — verified empirically against Amplify
  // v6 — so if these two statements were reversed our choice would be silently
  // overwritten and a session/memory/cookie DEFAULT_AUTH_STORAGE_KIND would still
  // ship as localStorage. Do not reorder them.
  //
  // Routing through getAuthStorage() also means changing DEFAULT_AUTH_STORAGE_KIND
  // swaps token persistence app-wide without touching this wiring or feature code.
  //
  // Scope: this configures the Cognito user-pool TOKEN store only. A future
  // identity pool, or a Hosted-UI / OAuth sign-in, keeps state in Amplify stores
  // this seam does not set — revisit the seam if either is added.
  cognitoUserPoolsTokenProvider.setKeyValueStorage(getAuthStorage());

  configured = true;
}

export default configureAmplify;
